(function () {
  if (typeof Swiper === 'undefined') return;

  // Desktop slider (more than 4 cards)
  var desktopSlider = document.querySelector('.categories-slider');
  if (desktopSlider) {
    new Swiper('.categories-slider', {
      effect: 'slide',
      speed: 1000,
      loop: true,
      slidesPerView: 4,
      spaceBetween: 8,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.categories-slider .swiper-pagination',
        clickable: true
      }
    });
  }

  // Mobile slider
  var mobileSlider = document.querySelector('.categories-slider-mobile');
  if (mobileSlider) {
    new Swiper('.categories-slider-mobile', {
      effect: 'cards',
      grabCursor: true,
      loop: true,
      speed: 700,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.categories-slider-mobile .swiper-pagination',
        clickable: true
      }
    });
  }

})();